"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThresholdTriagePolicy = exports.TriagePolicy = void 0;
const consensus_types_1 = require("../consensus.types");
class TriagePolicy {
}
exports.TriagePolicy = TriagePolicy;
class ThresholdTriagePolicy extends TriagePolicy {
    constructor(min = 1, minQuorum = 1) {
        super();
        this.min = min;
        this.minQuorum = minQuorum;
    }
    triagePathFor(tally) {
        return tally.candidates.some((candidate) => this.meetsAutoAcceptBar(candidate)) ?
            consensus_types_1.TriagePath.AutoAccept
            : consensus_types_1.TriagePath.ExpertReview;
    }
    meetsAutoAcceptBar(candidate) {
        return candidate.confidence >= this.min && candidate.voteCount >= this.minQuorum;
    }
}
exports.ThresholdTriagePolicy = ThresholdTriagePolicy;
//# sourceMappingURL=triage-policy.js.map